import React from "react";
import { connect } from "react-redux";
import language from "../../language";
import handleSearch from "../../utils/handleSearch";
import { Table } from "../Table";
import { fetchNegotiatedRates } from "../../queries/bank/ratesQuery";
import { fetchAllActiveBanks } from "../../queries/bank/activeBanksQuery";
import { fetchAccountCharges } from "../../queries/bank/chargesQuery";

let copyData = [];

class Rates extends React.Component {
  state = {
    isLoading: false,
    selected_data: {},
    data: [],
  };

  componentDidMount() {
    this.getData(true);
  }

  getData = async (isLoading) => {
    const { defaultLanguage, accountId } = this.props;
    try {
      this.setState({ isLoading });

      const data = await fetchAccountCharges(defaultLanguage, { accountId });

      console.log({ data });

      this.setState({
        isLoading: false,
        data,
      });
    } catch (error) {
      this.setState({ isLoading: false });
    }
  };

  handlePagination(page) {
    this.setState(
      {
        page,
      },
      () => {
        this.getData(true);
      }
    );
  }

  returnTableHeaders() {
    let headers = [
      {
        title: language[this.props.defaultLanguage].charge_type,
        key: "chargeType",
      },
      {
        title: language[this.props.defaultLanguage].value,
        key: "value",
      },
      {
        title: language[this.props.defaultLanguage].charge_value_type,
        key: "chargeValueType",
      },
    ];

    return headers;
  }

  render() {
    return (
      <>
        <Table
          data={this.state.data}
          isSearch
          page={this.state.page}
          limit={this.state.limit}
          search_text={this.state.search_text}
          handleSearch={(e) =>
            handleSearch(this, {
              copyData,
              value: e.target.value,
            })
          }
          showAdd={this.props.showAdd}
          addButtonText={language[this.props.defaultLanguage].add_account}
          totalPageCount={this.state.totalPageCount}
          isLoading={this.state.isLoading}
          handlePagination={this.handlePagination.bind(this)}
          headers={this.returnTableHeaders()}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(Rates);
